module.exports = __webpack_public_path__ + "images/camouflaged-9c26f1bf9d47f14fc961b9531c3e06a6.png";